import BaseIntegration from '../../vendors/base_integration';

class IntegrationB2C extends BaseIntegration {
    /**
     *
     * @type {string}
     * @private
     */
    _role = 'b2c';


    init(params) {
        super.init(params);
    }
}


export default IntegrationB2C;